import type { DocsItem } from "@academy/components"

export const AGREEMENT_PARTNER_STATIC: DocsItem[] = [
  {
    title: "1. Introduction",
    content: [
      "Please read this Partner Agreement and Terms of Service carefully before using the KidsCrafts.shop marketplace at https://kidscrafts.shop. This Agreement sets forth the terms and conditions that govern your use of the platform. By accessing or using KidsCrafts.shop, you agree to be bound by this Agreement. If you do not agree to these terms, please do not use the platform.",
    ],
  },
  {
    title: "2. About KidsCrafts.shop",
    content: [
      "KidsCrafts.shop is a marketplace that allows kids to sell a variety of crafts they've made in various geographic locations while learning about financial literacy and acquiring diverse entrepreneurial skills and more. KidsCrafts.shop is not a party to contracts for sale between third-party sellers and buyers, nor is KidsCrafts.shop a traditional auctioneer.",
    ],
  },
  {
    title: "3. Account Registration",
    content: [
      "3.1. Account of a Partner/Manager/Moderator can be registered only by KidsCrafts.shop. You need to contact KidsCrafts.shop and provide with all necessary information.",
      "3.2. By entering account at the first time a Partner/Manager/Moderator agrees to this User Agreement.",
    ],
  },
  {
    title: "4. Role and Responsibilities",
    content: [
      "As a Partner/Manager/Moderator, your responsibility entails overseeing the operations of KidsCrafts.shop, which includes monitoring listings, moderating communications, and ensuring compliance with our policies. Your role is to support and guide young sellers in their entrepreneurial endeavors.",
    ],
  },
  {
    title: "5. Child Protection",
    content: [
      "The safety and well-being of children are our top priorities. You agree to uphold strict standards of child protection, including reporting any suspicious or inappropriate behavior to the KidsCrafts.shop team immediately",
    ],
  },
  {
    title: "6. User Conduct",
    content: [
      "6.1. When using KidsCrafts.shop, you agree to comply with all applicable laws and regulations. You must not use the platform for any unlawful, fraudulent, or unauthorized purposes.",
      {
        list: {
          description: "6.2. You agree not to engage in any of the following prohibited activities:",
          items: [
            "Violating any intellectual property rights or other proprietary rights of KidsCrafts.shop or third parties.",
            "Uploading, posting, or transmitting any content that is unlawful, harmful, defamatory, abusive, or otherwise objectionable.",
            "Interfering with or disrupting the operation of KidsCrafts.shop or the servers or networks connected to the platform.",
            "Causing harm or damage to any person or entity;",
          ],
        },
      },
    ],
  },
  {
    title: "7. Communication",
    content: [
      "All interactions with young sellers and other users must be professional, respectful, and appropriate. Partners/Managers/Moderators are expected to provide guidance and support in a positive and constructive manner.",
    ],
  },
  {
    title: "8. Confidentiality",
    content: [
      "You agree to maintain the confidentiality of all sensitive information shared by young sellers and other users on KidsCrafts.shop. Personal information should never be shared without explicit consent.",
    ],
  },
  {
    title: "9. Conflict Resolution",
    content: [
      "In the event of disputes or conflicts between users, Partners/Managers/Moderators are expected to facilitate communication, mediate disagreements, and work towards a fair resolution for all parties involved.",
    ],
  },
  {
    title: "10. Reporting",
    content: [
      "Any concerns or incidents that may compromise the safety or integrity of KidsCrafts.shop should be reported promptly to the platform administrators. Your vigilance and proactive approach are essential in maintaining a secure environment for young entrepreneurs.",
    ],
  },
  {
    title: "11. Intellectual Property",
    content: [
      "11.1. KidsCrafts.shop and its content, including but not limited to logos, trademarks, images, text, graphics, and software (collectively the “Content”) found through the Website are owned or licensed by KidsCrafts.shop and may not be used, copied, broadcast, distributed, uploaded, posted or shared in any way without the express written consent of KidsCrafts.shop.",
      "11.2 KidsCrafts.shop expressly reserves all intellectual property rights in the Content. Nothing contained on the Website grants or should be construed as granting any license or right to use the Content for any purpose without the express written consent of KidsCrafts.shop.",
    ],
  },
  {
    title: "12. Privacy Policy",
    content: [
      {
        html: 'All personal information we collect through the Website is subject to our Privacy Policy. By using the Website, you consent to all actions taken by KidsCrafts.shop with respect to your personal information in compliance with the Privacy Policy. For a detailed description of KidsCrafts.shop’s personal information collection practices, please see our Privacy Policy at <a class="underline text-primary" target="_blank" href="https://kidscrafts.shop/privacy-policy/">https://kidscrafts.shop/privacy-policy/</a>',
      },
    ],
  },
  {
    title: "13. Funding",
    content: [
      "13.1. KidsCrafts.shop provides a platform for children to sell their handmade crafts and for buyers to purchase these crafts.",
      "13.2. For Partners/Managers/Moderators are provided payments in the amount of 5% of the sale.",
      "13.3. Payments will be credited to the bank account after 30 days.",
    ],
  },
  {
    title: "14. Applicable Law and Dispute Resolution",
    content: [
      "14.1. This Agreement shall be governed in accordance with the laws of British Columbia, Canada, without regard to its principles concerning conflicts of laws. All disputes, questions or differences whatsoever which shall at any time hereafter arise between the parties hereto (including the Company) or their respective representatives or any of them, and which the parties are unable to settle amicably between them, concerning or relating to this Agreement or the validity, construction, meaning, operation or effect thereof, or any clause herein contained, or as to the rights, duties or liabilities of the Parties hereto under or by virtue of this Agreement, shall be finally settled under the Commercial Arbitration Act of British Columbia, Canada. Arbitration proceedings shall take place in Vancouver, British Columbia, Canada.",
      "14.2. Any disputes arising from the use of the Website shall be resolved in accordance with the laws of British Columbia, Canada.",
    ],
  },
]
